import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRemoveCompanyRegistrationMutation } from "../../../companiesApiSlice";

const RejectDialog = ({ onClose, open, companyId, companyName }) => {
	const { t } = useTranslation();
	const [removeCompany, { isLoading }] = useRemoveCompanyRegistrationMutation();

	const {
		handleSubmit,
		formState: { errors },
	} = useForm({
		shouldFocusError: true,
	});

	const handleRemoveCompany = async () => {
		await removeCompany({ companyId }).unwrap();
	};

	return (
		<Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
			<Box sx={{ padding: "30px" }}>
				<Box component="form" onSubmit={handleSubmit(handleRemoveCompany)}>
					<Grid container rowSpacing={3} columnSpacing={2}>
						<Grid size={12}>
							<Box sx={{ textAlign: "center" }}>
								<Typography variant="h5" component="span">
									{t("are_you_sure_to_remove_file_in_database_for")}:{" "}
									{companyName}?
								</Typography>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button
									type="submit"
									loading={isLoading}
									variant="contained"
									color="error"
								>
									{t("remove")}
								</Button>
							</Box>
						</Grid>
						<Grid size={6}>
							<Box sx={{ display: "flex", justifyContent: "start" }}>
								<Button variant="contained" color="secondary" onClick={onClose}>
									{t("cancel")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default RejectDialog;
